import { FileSpreadsheet } from 'lucide-react'
import React from 'react'
import './FyTrialBalance.css'

const FyTrialBalance = () => {
  return (
    <>
      <div className="fyTrial-balance-container">
      {/* Page Title */}
      <h1 className="fyTrial-balance-title">FY Trial Balance</h1>

      {/* Filter Section */}
      <div className="fyTrial-balance-filterBox">
        <div className="fyTrial-balance-filter-title">Filter By</div>
        <div className="fyTrial-balance-filter-item-div">
          <div className="fyTrial-balance-filter-item">
            <label>Branch</label>
            <select>
              <option value="">Select Branch</option>
              {/* <option value="Bareilly">Bareilly</option>
              <option value="Delhi">Delhi</option>
              <option value="Mumbai">Mumbai</option> */}
            </select>
          </div>

          <button className="fyTrial-balance-filter-btn">Filter</button>
        </div>
      </div>

      {/* Reports */}
       <div className="fyTrial-balance-report-section">
          <div className="fyTrial-balance-report-top">
            <h2>Latest Orders</h2>
            <button><FileSpreadsheet size={15}/> Export</button>
          </div>

          <div className="fyTrial-balance-report-table">
            <table>
              <thead>
                <tr>
                  <th>Particular</th>
                  <th>Opening</th>
                  <th>Debit</th>
                  <th>Credit</th>
                  <th>Closing</th>
                </tr>
              </thead>

              <tbody>
                {/* Row Sample */}
                <tr>
                  <td>Dummy</td>
                  <td>Dummy</td>
                  <td style={{color:"green"}}>Dummy</td>
                  <td style={{color:"red"}}>Dummy</td>
                  <td>Dummy</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
    </div>
    </>
  )
}

export default FyTrialBalance
